import BaseController from '../../lib/BaseController';
import Utils from '../utility/Utils';

class PSMDetailsController extends BaseController {
    constructor(parentController, customerId, psmLink, psmNumber, serviceLevelId, displayClearButton) {
        super('psm-details', {
            psmLink: psmLink,
            psmNumber: psmNumber,
            serviceLevelId: serviceLevelId.id===Utils.emptyGuid?null : serviceLevelId,
            disablePSM: psmNumber ? true : false,
            displayClearButton: displayClearButton,
            customerId: customerId,
            parentController: parentController,
            errors: {}
        });
        this.saving = false;
    }

    clear() {
        this.state.displayClearButton = false;
        this.state.psmLink = '';
        this.commit();
    }

    save = () => {
        const state = this.state;
        var validPSMNumber = state?.psmNumber?.replace(/\s+/g, '').length === state?.psmNumber?.length ? true : false;
        if (!validPSMNumber) {
            this.state.errors.psmNumber = 'Please enter valid PSM number';
            this.commit();
            return false;
        }
        this.state.parentController.savePSMDetails(state.psmLink, state.psmNumber, state.serviceLevelId);
        return true;
    }
}

export default PSMDetailsController;